import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  Article,
  Campaign,
  PhoneIphone,
  // Newspaper,
  // PhotoLibrary,
  HelpOutline,
} from "@mui/icons-material";
// import PageHeader from "../PageHeader";
// import resourcesBg from "../../../../../assets/img/contactless.jpg";

const resources = [
  {
    title: "Blogs & Insights",
    description:
      "Thought leadership and practical insights on digital payments, financial inclusion, and public-sector digitisation.",
    icon: <Article />,
    link: "/resources#blogs",
  },
  {
    title: "Testimonials",
    description:
      "Real stories from governments, SACCOs, merchants, and partners using OnePayX across Uganda.",
    icon: <Campaign />,
    link: "/resources#testimonials",
  },
  {
    title: "Mobile Apps",
    description:
      "Download official OnePayX mobile applications and complementary tools.",
    icon: <PhoneIphone />,
    link: "/resources#apps",
  },
  // {
  //   title: "News & Updates",
  //   description:
  //     "Official announcements, product launches, partnerships, and regulatory milestones.",
  //   icon: <Newspaper />,
  //   link: "/resources/news",
  // },
  // {
  //   title: "Media Center",
  //   description:
  //     "Photos and videos from launches, trainings, community outreach, and public events.",
  //   icon: <PhotoLibrary />,
  //   link: "/resources/media",
  // },
  {
    title: "FAQs",
    description:
      "Answers to common questions about security, integrations, and usage.",
    icon: <HelpOutline />,
    link: "/resources#faq",
  },
];

export default function ResourcesOverview() {
  return (
    <>
      {/* <PageHeader
        title="OnePayX Resource Centre"
        description="Insights, updates, and support materials to help you understand and maximise the OnePayX ecosystem."
        height="65vh"
        backgroundImage={resourcesBg}
      /> */}

      <Wrapper data-aos="fade-up" className="container">
        <Grid>
          {resources.map((item, i) => (
            <Card key={i}>
              <IconWrap>{item.icon}</IconWrap>

              <Content>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <StyledLink to={item.link}>Explore →</StyledLink>
              </Content>
            </Card>
          ))}
        </Grid>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.section`
  padding: 80px 20px;
`;

const Grid = styled.div`
  display: grid;
  gap: 32px;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Card = styled.div`
  display: flex;
  gap: 24px;
  padding: 28px;
  background: linear-gradient(135deg, #f9fbff, #ffffff);
  border-radius: 18px;
  border: 1px solid #e6edf5;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: #1b75bb;
  }
`;

const IconWrap = styled.div`
  min-width: 56px;
  height: 56px;
  border-radius: 14px;
  background: #1b75bb;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: #fff;
    font-size: 28px;
  }
`;

const Content = styled.div`
  h3 {
    font-size: 1.35rem;
    margin-bottom: 8px;
    color: #1b75bb;
  }

  p {
    font-size: 0.95rem;
    color: #555;
    line-height: 1.6;
    margin-bottom: 14px;
  }
`;

const StyledLink = styled(Link)`
  font-weight: 600;
  color: #1b75bb;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
